import { EHeatingSource } from '../../types/filters';

interface IHeatingSource {
  label: string;
  value: EHeatingSource;
}

export const HEATING_SOURCES: IHeatingSource[] = [
  { label: 'Угольное', value: EHeatingSource.Coal },
  { label: 'Камин', value: EHeatingSource.Fireplace },
  { label: 'Газовое', value: EHeatingSource.Gas },
  { label: 'Печь', value: EHeatingSource.Stove },
  { label: 'Без отопления', value: EHeatingSource.Without },
];
